import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Meerut Official Mobile App</h1>
                <p>Home &gt; Mobile App</p>
            </div>
        </div>
    )
}

export default Hero;